import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './lang/zh'
import en from './lang/en'

Vue.use(VueI18n)

const messages = {
    zh_CN: {
        // 简体中文
        ...zh
    },
    zh_TW: {
        // #繁体中文(台湾)
    },
    en_US: {
        // #英文
        ...en
    },
    th_TH: {
        // #泰语
    },
    vi_VN: {
        // #越南语
    },
    ja_JP: {
        // #日语
    },
    ko_KR: {
        // #韩语
    },
    de_DE: {
        // #德语
    },
    fr_FR: {
        // #法语
    },
    es_ES: {
        // #西班牙语
    },
    ru_RU: {
        // #俄语
    },
    pt_BR: {
        // #葡萄牙语
    },
    it_IT: {
        // #意大利语
    },
    tr_TR: {
        // #土耳其语
    },
    ar_EG: {
        // #阿拉伯语
    },
    id_ID: {
        // #印尼语
    },
    zh_HK: {
        // #繁体中文(香港)
    },
    zh_SG: {
        // #繁体中文(新加坡)
    },
    zh_MO: {
        // #繁体中文(澳门)
    }
}

// eslint-disable-next-line new-cap,no-new
const i18n = new VueI18n({
    locale: localStorage.getItem('emis-lang') || 'zh_CN',
    silentTranslationWarn: true,
    fallbackLocale: 'zh_CN',
    messages
})

export default i18n

export function setI18nDict (dict) {
    i18n.mergeLocaleMessage('zh_CN', dict.zh || {})
    i18n.mergeLocaleMessage('en_US', dict.en || {})
}



// WEBPACK FOOTER //
// ./src/i18n/index.js